import i18next from 'i18next';

i18next.addResources('es_CL', 'Field', {
  email: 'Email'
});

i18next.addResources('es_CR', 'Field', {
  email: 'Email'
});
